module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADUSURBVHgBlZSBEcIgDEWlE3SEbmBH6CbtCG4gI7CBOoFu0BHUCdAJ6gYxXMGLNAT4d//gQnjQS4raVQgABhz26Df6oZR6+XiL809ImlwgAzrCvxa0Rhs30sS7d5cATZCW9dA2JFuyMDKwGWQdaLJmThvRfXQYJxOf3GU2LMKaDpzGj1e0VABpzcawS2aDpOcmAmuJa2UpoyHzm3eNNBstKIJ4qxTwXAKCRIPHwAHkJnWgXrqN+10M5Dt9zt6IfJ5lAK5hT7C+GKIUA3b99uu58MyU6AuPCySI1jVQsgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/pc/Vector.png
// module id = 305
// module chunks = 0